module.exports = __webpack_public_path__ + "img/MASTER_ENG_VP_Handbook_Web21.67308882.jpg";